import React from 'react'
import FeatureTable from './components/FeatureTable'
import { Cell, CheckCell, ValueCell } from './components/ValueCell'
import service from './images/service.png'

const Service = () => {
  return (
    <FeatureTable title="服务支持" icon={service}>
      <>
        <tr>
          <Cell>在线客服</Cell>
          <ValueCell />
          <CheckCell />
          <CheckCell />
          <CheckCell />
        </tr>
        <tr>
          <Cell>1v1客户成功经理</Cell>
          <ValueCell></ValueCell>
          <CheckCell />
          <CheckCell />
          <CheckCell />
        </tr>
        <tr>
          <Cell>1v1技术客服支持</Cell>
          <ValueCell></ValueCell>
          <ValueCell></ValueCell>
          <CheckCell />
          <CheckCell />
        </tr>
        <tr>
          <Cell>产品远程培训1次</Cell>
          <ValueCell></ValueCell>
          <ValueCell></ValueCell>
          <ValueCell></ValueCell>
          <CheckCell />
        </tr>
      </>
    </FeatureTable>
  )
}

export default Service
